export enum EcommerceTemplateAlias {
    OnlineRevenueChange = "ecommerce-online-revenue-change",
    OnlineRevenueReached = "ecommerce-online-revenue-reached",
    OnlineTransactionsChange = "ecommerce-online-transactions-change",
    OnlineTransactionsReached = "ecommerce-online-transactions-reached",
}
